<div class="row mx-0">
    <div class="new-header d-flex align-items-center justify-content-between w-100 px-3 py-3 common--header"
        style="border-bottom: 1px solid #DEE8F1;">
        <div class="header-content">
            Training Tutorials
        </div>
        <div class="d-flex align-items-center">
            <app-notification-icon></app-notification-icon>
        </div>
    </div>
    <div class="send-payment-inv p-2">
        <div class="d-flex justify-content-start align-items-center mt-3 pointer">
            <figure class="ms-2" (click)="routeMe()">
                <img src="assets\img\svg\back_arrow.svg" class="p-1 border border_50" alt="">
            </figure>
        </div>
    </div>

    <div class="row m-0">
        <div class="col-xl-3 ps-4" *ngFor="let video_item of tutorial_videos">
            <div class="card-body" *ngIf="video_item">
                <div class="row">
                    <div class="col-12" tappable (click)="selected_video = video_item; openDialog()">
                        <figure>
                            <img class="w-100 mb-2" [src]="video_item.thumb_url" alt="">
                            <img src="assets/img/png/play.png" class="video-icon">
                        </figure>
                        <span class="txt-card">{{video_item.vid_name}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>